import SpinnerIcon from '~/public/assets/images/svg/loader-spinner-icon.svg';

interface SpinnerProps {
  containerClassName?: string;
  spinnerClassName?: string;
}
const Spinner = ({
  containerClassName = '',
  spinnerClassName = '',
}: SpinnerProps) => {
  return (
    <div
      className={`mx-auto flex h-full w-full flex-col items-center justify-center ${containerClassName}`}
    >
      <SpinnerIcon
        className={`h-14 w-14 animate-spin text-secondary-300 ${spinnerClassName}`}
      />
    </div>
  );
};

export default Spinner;
